var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-search',_vm._b({attrs:{"fields":_vm.form,"no-search-btn":"","disable-pop":""},on:{"change":_vm.whenSearchChange}},'table-search',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }